// @flow
import { GET_PRODUCTS, RECEIVE_PRODUCTS } from '~/core/state/products/constants';
import { GET_RECIPES, RECEIVE_RECIPES } from '~/core/state/recipes/constants';
import { GET_WEATHER, RECEIVED_WEATHER } from '~/core/state/weather/constants';
import { LOAD_DEVICES, RECEIVE_DEVICES, REQUEST_DEVICES } from '~/core/state/devices/constants';
import { ANALYTICS_SHARING_TOGGLED, PIN_SET, RESET_PIN_ERROR, SETTING_PIN } from './constants';

import type { Action } from './types';
import { DATE_TIME_INTERVAL } from '~/core/state/hub/constants';
import { fromJS } from 'immutable';
import handleReduce from '~/core/state/handle-reduce';
import { INITIALIZE_STATE } from '~/core/state/holiday-mode/constants';
import { logIn } from '~/core/state/application/actions';
import { SAVE_NOTIFICATIONS } from '~/core/state/notifications/constants';

// $FlowFixMe
export default (state: typeof fromJS = fromJS({}), action: Action) => {
    let nextState = state;

    switch (action.type) {
        case ANALYTICS_SHARING_TOGGLED:
            nextState = handleReduce(() =>
                // SENSEDO PASS RESPONSE FROM API
                state.setIn(['media', 'allowAnalyticsSharing'], !state.getIn(['media', 'allowAnalyticsSharing']))
            )(state, action);

            break;
        case logIn.toString():
            nextState = handleReduce(() =>
                state
                    .set('userDetails', fromJS(action.payload.user))
                    .set('alerts', fromJS(action.payload.alerts))
                    .set('media', fromJS(action.payload.media))
            )(state, action);

            break;
        case PIN_SET:
            nextState = handleReduce(() =>
                state.withMutations(state => state.set('settingPin', false).set('settingPinError', false))
            )(state, action);

            break;
        case RESET_PIN_ERROR:
            nextState = handleReduce(() => state.set('settingPinError', false))(state, action);

            break;
        case SAVE_NOTIFICATIONS:
            nextState = handleReduce(() => state.setIn(['alerts', 'warningsEmail'], action.payload.warningsEnabled))(
                state,
                action
            );

            break;
        case SETTING_PIN:
            nextState = handleReduce(
                () => state.withMutations(state => state.set('settingPin', true).set('settingPinError', false)),
                () => state.withMutations(state => state.set('settingPin', false).set('settingPinError', true))
            )(state, action);

            break;
        default:
            break;
    }

    const blacklistedActionTypes = [
        DATE_TIME_INTERVAL,
        GET_PRODUCTS,
        GET_RECIPES,
        GET_WEATHER,
        INITIALIZE_STATE,
        LOAD_DEVICES,
        RECEIVE_DEVICES,
        RECEIVE_PRODUCTS,
        RECEIVE_RECIPES,
        RECEIVED_WEATHER,
        REQUEST_DEVICES
    ];

    if (!blacklistedActionTypes.includes(action.type) && action.meta && action.meta.activityStamp) {
        nextState = nextState.set('lastActivity', action.meta.activityStamp);
    }

    return nextState;
};



// WEBPACK FOOTER //
// ./src/core/state/user/index.js